import { render, staticRenderFns } from "./KeyEdit.vue?vue&type=template&id=6cbf972f&scoped=true"
import script from "./KeyEdit.vue?vue&type=script&lang=js"
export * from "./KeyEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbf972f",
  null
  
)

export default component.exports